/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: HttpRequestPost.ts
 * Created by: Kevin
 * Create Date: 2022-12-09 18:19
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import ApiUrlBuilder from "@/commons/https/ApiUrlBuilder";
import {HttpRequest} from "@/commons/https/HttpRequest";
import axios from "axios";
import HttpTokenProvider from "@/commons/https/HttpTokenProvider";
import HttpRequestConfig from "@/commons/https/HttpRequestConfig";

export default class HttpRequestPost extends HttpRequest {

    private readonly uri: string
    private readonly formData: FormData;

    public constructor(apiUrlBuilder: ApiUrlBuilder, uri: string, cfg: HttpRequestConfig | null, formData: FormData) {
        super(apiUrlBuilder, cfg);
        this.uri = uri;
        this.formData = formData;
    }

    public execute(token?: HttpTokenProvider | null): Promise<any> {
        HttpTokenProvider.set(this.requestConfig, token);
        const targetURL = this.getTargetURL();
        return axios.post(targetURL, this.formData, this.requestConfig);
    }

    public getTargetURL(): string {
        return this.apiUrlBuilder.resolve(this.uri);
    }

}